'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_2fab7c71 = {"container":"Carousel_module_container__87cb0c2a","header":"Carousel_module_header__87cb0c2a","hidden":"Carousel_module_hidden__87cb0c2a","title":"Carousel_module_title__87cb0c2a","slides-wrapper":"Carousel_module_slidesWrapper__87cb0c2a","gradient":"Carousel_module_gradient__87cb0c2a","right-gradient":"Carousel_module_rightGradient__87cb0c2a","left-gradient":"Carousel_module_leftGradient__87cb0c2a","slides":"Carousel_module_slides__87cb0c2a","bottom-controls":"Carousel_module_bottomControls__87cb0c2a"};
require("../../../assets/cjs/components/Carousel/src/Carousel~C7diXijA.css");

exports.default = modules_2fab7c71;
//# sourceMappingURL=Carousel.module.less.js.map
